import React, { useEffect, useState } from 'react';
import { bool, string } from 'prop-types';

import {connect} from 'react-redux';

import * as WizardActions from '../../actions/wizardActions';

import EsmsDialog from '../../components/EsmsDialog';

import classes from './MessageModal.module.css';

const MessageModal = ({
    message,
    open,
    title,
    ...props
}) => {
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        setAnimate(true);

        setTimeout(() => {
            setAnimate(false);
        }, 500);
    }, [message]);

    return (
        <EsmsDialog
            open={open}
            title={title}
            cancelable={false}
            hideButtons
            {...props}
        >
            <div className={classes.container}>
                <span className={animate ? classes.fadeCycle : ''}>
                    {message}
                </span>
            </div>
        </EsmsDialog>
    );
};

MessageModal.defaultProps = {
    message: '',
    open:    false,
    title:   ''
};

MessageModal.propTypes = {
    message: string,
    open:    bool,
    title:   string
};

const mapStateToProps = state => {
    return {
        message: state.wizard.message
    };
};

const mapDispatchToProps = {
    ...WizardActions
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageModal);
